import { useState, useRef, useEffect } from "react";

import Header from "../components/Header";
import Plans from "../components/Plans";
import WhatWeDo from "../components/WhatWeDo";
import './Index.css';

import Button from '@mui/material/Button';
import HowItWorks from "../components/HowItWorks";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import TextField from '@mui/material/TextField';
import { ReactTyped } from "react-typed";

import { motion } from "framer-motion";
import Chip from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PlaceIcon from '@mui/icons-material/Place';
// import { gerarLinkWhatsApp } from "../../utils/WhatsappLink";
import SimulacaoImpostos from "../components/SimulacaoImpostos";
import { Divider } from "@mui/material";
import Box from '@mui/material/Box';
import WhatsAppButton from "../components/WhatsAppButton";
// import { Divider } from "@mui/material";

function Home() {
    const navigate = useNavigate();

    const [cidades, setCidades] = useState([]);
    const [cidadesFiltered, setCidadesFiltered] = useState([]);

    // const parseCSVLine = (line) => {
    //     // Vai separar por vírgula apenas fora de aspas
    //     const regex = /(".*?"|[^",\s]+)(?=\s*,|\s*$)/g;
    //     return line.match(regex).map(field => field.replace(/^"|"$/g, ''));
    // };


    useEffect(() => {
        window.scrollTo(0, 0);

        let pathCsv = "/assets/csvCidades/Cidades homologadas - 14-11-2025.csv";

        const reader = new FileReader();
        fetch(pathCsv)
            .then(response => response.blob())
            .then(blob => {
                reader.readAsText(blob);
            });
        reader.onload = () => {
            const csvData = reader.result;
            const lines = csvData.split('\n').slice(1); // Ignora o cabeçalho
            for (let line of lines) {
                let [status, cidade, uf, layoutIntegracao, padrao, documentacaoDoPadrao, codigoIbge, dadosObrigatoriosDasNotasTomadas, notasTomadas, login, senha, multiplosServicos, certificado] = line.split(',').map(field => field.replace(/^"|"$/g, '').trim());
                setCidades(prevCidades => [...prevCidades, { status, cidade, uf, layoutIntegracao, padrao, documentacaoDoPadrao, codigoIbge, dadosObrigatoriosDasNotasTomadas, notasTomadas, login, senha, multiplosServicos, certificado }]);
            }
        }
    }, [])
    const cards = [
        { value: "Médicos", img: "/assets/nichosMedico.jpeg", desc: "Contabilidade especializada para médicos de todas as especialidades." },
        { value: "Odontologistas", img: "/assets/nichosDentista.jpeg", desc: "Foco na rotina fiscal e tributária dos profissionais de odontologia." },
        { value: "Fisioterapeutas", img: "/assets/nichosFisioterapia.jpeg", desc: "Gestão contábil personalizada para quem trabalha com reabilitação, pilates e terapias integrativas." },
        { value: "Clínicas e Centros de Saúde", img: "/assets/nichosClinicas.jpeg", desc: "Estrutura contábil completa para empresas da área da saúde que atuam com múltiplos profissionais e serviços." },
        { value: "Profissionais Autônomos da Saúde", img: "/assets/nichosAutonomos.jpeg", desc: "Para quem atende de forma independente ou domiciliar e precisa de organização fiscal simples e eficaz." },
        { value: "Psicólogos e Terapeutas", img: "/assets/nichosPsicologo.jpeg", desc: "Soluções sob medida para profissionais que atuam com saúde mental e bem-estar." },
        // { value: "Radiologistas", img: "/assets/raiox.png", desc: "Exames de imagem realizados com precisão para auxiliar no diagnóstico e acompanhamento médico." },
        { value: "Profissionais de Pediatria", img: "/assets/pediatra.jpg", desc: "Cuidado dedicado à saúde infantil, com atenção especial ao desenvolvimento físico e emocional das crianças." },
        { value: "Personal Trainer", img: "/assets/personal.jpg", desc: "Acompanhamento individualizado para melhorar sua saúde, desempenho físico e qualidade de vida com treinos personalizados." },
    ];

    const plansRef = useRef(null);

    const cardVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: i => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.1, duration: 0.4 }
        }),
    };

    const scrollToPlans = () => {
        plansRef.current?.scrollIntoView({ behavior: 'smooth' });
    };


    const handleFilterCity = (input) => {
        if (!input) {
            setCidadesFiltered([]);
            return;
        }
        const normalizeText = (text) =>
            text
                .normalize('NFD') // separa caracteres + acentos
                .replace(/[\u0300-\u036f]/g, '') // remove acentos
                .replace(/\s+/g, ' ') // normaliza espaços
                .trim()
                .toLowerCase();

        const filtered = cidades
            .filter(cidade => {
                const cidadeNormalized = normalizeText(cidade.cidade);
                const inputNormalized = normalizeText(input);
                return cidadeNormalized.includes(inputNormalized);
            })
            .slice(0, 2);


        if (filtered.length === 0) {
            setCidadesFiltered(false);
            return;
        }
        setCidadesFiltered(filtered);
    }

    return (
        <>
            <Header />
            <Box
                component="section"
                sx={{
                    width: "100%",
                    minHeight: { xs: "100svh", md: "100vh" },
                    backgroundImage: 'url("/assets/banner.jpg")',
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    boxSizing: "border-box",
                    pt: "80px",
                }}
            >
                {/* Overlay em degradê (azul da marca) para contraste */}
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        zIndex: 1,
                        background: {
                            xs: "linear-gradient(180deg, rgba(11, 36, 61, 0.80) 0%, rgba(11, 36, 61, 0.92) 100%)",
                            md: "linear-gradient(90deg, rgba(11, 36, 61, 0.95) 0%, rgba(11, 36, 61, 0.80) 45%, rgba(11, 36, 61, 0.30) 100%)",
                        },
                    }}
                />

                {/* Conteúdo sobre a imagem (alinhado com o header) */}
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 2,
                        width: "90%",
                        maxWidth: "1280px",
                        py: { xs: 6, md: 8 },
                    }}
                >
                    <motion.div
                        style={{ maxWidth: "680px", color: "#fff" }}
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <motion.div
                            initial={{ opacity: 0, y: -10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.2, duration: 0.5 }}
                        >
                            <Box
                                sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 1,
                                    px: 1.75,
                                    py: 0.75,
                                    mb: 3,
                                    borderRadius: "999px",
                                    backgroundColor: "rgba(255, 200, 69, 0.12)",
                                    border: "1px solid rgba(255, 200, 69, 0.4)",
                                    color: "#ffc845",
                                    fontSize: { xs: "0.75rem", md: "0.8rem" },
                                    fontWeight: 600,
                                    letterSpacing: "0.5px",
                                    textTransform: "uppercase",
                                }}
                            >
                                <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "#ffc845" }} />
                                Contabilidade especializada em saúde
                            </Box>
                        </motion.div>

                        <motion.h1
                            style={{ margin: "0 0 20px", fontSize: "clamp(2rem, 5vw, 3.5rem)", fontWeight: 800, lineHeight: 1.15, letterSpacing: "-0.5px" }}
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.3, duration: 0.6 }}
                        >
                            A contabilidade para quem{" "}
                            <span style={{ color: "#ffc845" }}>cuida da saúde.</span>
                        </motion.h1>

                        <motion.p
                            style={{ margin: "0 0 36px", fontSize: "clamp(1rem, 1.6vw, 1.2rem)", lineHeight: 1.65, color: "rgba(255, 255, 255, 0.85)" }}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.6, duration: 0.6 }}
                        >
                            Se você é médico, dentista, psicólogo, fisioterapeuta ou profissional da área da saúde, conheça os planos da Clarea feitos sob medida para sua rotina!
                        </motion.p>

                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.9, duration: 0.6 }}
                        >
                            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 1.5 }}>
                                <Button
                                    variant="contained"
                                    onClick={() => navigate("../Planos")}
                                    sx={{
                                        px: 4,
                                        py: 1.75,
                                        fontSize: "1rem",
                                        fontWeight: 700,
                                        textTransform: "none",
                                        backgroundColor: "#ffc845",
                                        color: "#0b243d",
                                        borderRadius: "10px",
                                        boxShadow: "0 8px 24px rgba(255, 200, 69, 0.35)",
                                        transition: "all 0.2s ease",
                                        '&:hover': {
                                            backgroundColor: "#e9b53d",
                                            transform: "translateY(-2px)",
                                            boxShadow: "0 10px 28px rgba(255, 200, 69, 0.45)",
                                        },
                                    }}
                                >
                                    Contrate agora
                                </Button>
                                <Button
                                    variant="outlined"
                                    onClick={() => navigate("../Solucoes")}
                                    sx={{
                                        px: 4,
                                        py: 1.75,
                                        fontSize: "1rem",
                                        fontWeight: 600,
                                        textTransform: "none",
                                        color: "#fff",
                                        borderColor: "rgba(255, 255, 255, 0.4)",
                                        borderRadius: "10px",
                                        backdropFilter: "blur(4px)",
                                        transition: "all 0.2s ease",
                                        '&:hover': {
                                            borderColor: "#fff",
                                            backgroundColor: "rgba(255, 255, 255, 0.08)",
                                            transform: "translateY(-2px)",
                                        },
                                    }}
                                >
                                    Troque de contador
                                </Button>
                            </Box>
                        </motion.div>

                        {/* Diferenciais */}
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 1.2, duration: 0.6 }}
                        >
                            <Box
                                sx={{
                                    mt: 5,
                                    pt: 3,
                                    borderTop: "1px solid rgba(255, 255, 255, 0.12)",
                                    display: "flex",
                                    flexDirection: { xs: "column", sm: "row" },
                                    flexWrap: "wrap",
                                    gap: { xs: 1.25, sm: 3 },
                                }}
                            >
                                {["Sem multa e sem fidelidade", "Suporte da nossa equipe", "Acesso imediato à plataforma"].map((item) => (
                                    <Box key={item} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <Box
                                            sx={{
                                                width: 20,
                                                height: 20,
                                                borderRadius: "50%",
                                                backgroundColor: "rgba(255, 200, 69, 0.15)",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexShrink: 0,
                                            }}
                                        >
                                            <CheckIcon sx={{ fontSize: 14, color: "#ffc845" }} />
                                        </Box>
                                        <Box component="span" sx={{ fontSize: "0.9rem", color: "rgba(255, 255, 255, 0.85)" }}>
                                            {item}
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                        </motion.div>
                    </motion.div>
                </Box>
            </Box>

            <Box
                component="section"
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    backgroundColor: "#fff",
                    py: { xs: 8, md: 12 },
                    overflow: "hidden",
                }}
            >
                <Box
                    sx={{
                        width: "90%",
                        maxWidth: "1280px",
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                        alignItems: "center",
                        gap: { xs: 6, md: 8 },
                    }}
                >
                    {/* Imagem com fade + scale */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.8 }}
                    >
                        <Box sx={{ position: "relative", maxWidth: { xs: "520px", md: "none" }, mx: "auto" }}>
                            {/* Detalhes decorativos */}
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: { xs: -24, md: -36 },
                                    left: { xs: -24, md: -36 },
                                    width: { xs: 110, md: 160 },
                                    height: { xs: 110, md: 160 },
                                    borderRadius: "50%",
                                    border: { xs: "20px solid #ffc845", md: "28px solid #ffc845" },
                                    opacity: 0.35,
                                    zIndex: 0,
                                }}
                            />
                            <Box
                                sx={{
                                    position: "absolute",
                                    right: { xs: -12, md: -20 },
                                    bottom: { xs: -12, md: -20 },
                                    width: "60%",
                                    height: "60%",
                                    borderRadius: "24px",
                                    backgroundColor: "#0b243d",
                                    zIndex: 0,
                                }}
                            />

                            <Box
                                component="img"
                                src="/assets/contabilidade-para-medicos.jpg"
                                alt="Profissional da saúde"
                                sx={{
                                    position: "relative",
                                    zIndex: 1,
                                    display: "block",
                                    width: "100%",
                                    height: "auto",
                                    borderRadius: "24px",
                                    objectFit: "cover",
                                    boxShadow: "0 20px 50px rgba(11, 36, 61, 0.25)",
                                }}
                            />

                            {/* Card flutuante */}
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.6, duration: 0.6 }}
                                style={{ position: "absolute", left: "-4%", bottom: "8%", zIndex: 2 }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1.5,
                                        backgroundColor: "#fff",
                                        borderRadius: "14px",
                                        px: { xs: 1.5, md: 2 },
                                        py: { xs: 1.25, md: 1.5 },
                                        boxShadow: "0 12px 30px rgba(11, 36, 61, 0.2)",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: { xs: 34, md: 40 },
                                            height: { xs: 34, md: 40 },
                                            borderRadius: "10px",
                                            backgroundColor: "#ffc845",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            flexShrink: 0,
                                        }}
                                    >
                                        <CheckIcon sx={{ color: "#0b243d", fontSize: { xs: 20, md: 24 } }} />
                                    </Box>
                                    <Box>
                                        <Box sx={{ fontSize: { xs: "0.8rem", md: "0.9rem" }, fontWeight: 700, color: "#0b243d", lineHeight: 1.2 }}>
                                            Obrigações fiscais em dia
                                        </Box>
                                        <Box sx={{ fontSize: { xs: "0.7rem", md: "0.78rem" }, color: "#6b7280", lineHeight: 1.3 }}>
                                            Sem dor de cabeça
                                        </Box>
                                    </Box>
                                </Box>
                            </motion.div>
                        </Box>
                    </motion.div>

                    {/* Texto com entrada da direita */}
                    <motion.div
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.8 }}
                    >
                        <Box
                            sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 1,
                                px: 1.75,
                                py: 0.75,
                                mb: 2.5,
                                borderRadius: "999px",
                                backgroundColor: "rgba(255, 200, 69, 0.18)",
                                color: "#0b243d",
                                fontSize: "0.8rem",
                                fontWeight: 700,
                                letterSpacing: "0.5px",
                                textTransform: "uppercase",
                            }}
                        >
                            <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "#ffc845" }} />
                            A Clarea
                        </Box>

                        {/* Altura reservada para o texto digitado não "empurrar" o conteúdo */}
                        <Box sx={{ fontSize: "clamp(1.8rem, 3.4vw, 2.6rem)", minHeight: { xs: "4.8em", md: "3.6em" }, mb: 2.5 }}>
                            <h2 style={{ margin: 0, fontSize: "inherit", fontWeight: 800, lineHeight: 1.2, letterSpacing: "-0.5px", color: "#0b243d" }}>
                                Somos uma contabilidade simples{" "}
                                <span style={{ color: "#c8961e" }}>
                                    <ReactTyped
                                        strings={[
                                            "para profissionais da saúde.",
                                            "para quem não tem tempo a perder.",
                                            "que entende a rotina da saúde."
                                        ]}
                                        typeSpeed={120}
                                        backSpeed={30}
                                        loop
                                    />
                                </span>
                            </h2>
                        </Box>

                        <Box component="p" sx={{ m: 0, fontSize: { xs: "1rem", md: "1.08rem" }, lineHeight: 1.7, color: "#4b5563" }}>
                            Somos uma contabilidade e assessoria tributária pensada para quem dedica a vida ao cuidado com as pessoas. Conhecemos as <b style={{ color: "#0b243d" }}>exigências e particularidades</b> do setor da saúde e oferecemos a <b style={{ color: "#0b243d" }}>tranquilidade</b> de estar em dia com as obrigações fiscais de forma <b style={{ color: "#0b243d" }}>prática e descomplicada</b>.
                        </Box>

                        {/* Benefícios */}
                        <Box
                            sx={{
                                mt: 4,
                                display: "grid",
                                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                                gap: 1.5,
                            }}
                        >
                            {[
                                { titulo: "Especialistas em saúde", texto: "Entendemos a rotina do seu consultório." },
                                { titulo: "Tudo em dia", texto: "Impostos e obrigações sem atrasos." },
                                { titulo: "100% descomplicado", texto: "Você cuida dos pacientes, nós do resto." },
                                { titulo: "Sem fidelidade", texto: "Cancele quando quiser, sem multa." },
                            ].map((item, index) => (
                                <motion.div
                                    key={item.titulo}
                                    initial={{ opacity: 0, y: 15 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: 0.3 + index * 0.1, duration: 0.4 }}
                                >
                                    <Box
                                        sx={{
                                            height: "100%",
                                            boxSizing: "border-box",
                                            display: "flex",
                                            alignItems: "flex-start",
                                            gap: 1.25,
                                            p: 1.75,
                                            borderRadius: "12px",
                                            backgroundColor: "#f9fafb",
                                            border: "1px solid #eef0f3",
                                            transition: "all 0.2s ease",
                                            "&:hover": { borderColor: "#ffc845", backgroundColor: "#fffbeb" },
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 24,
                                                height: 24,
                                                borderRadius: "50%",
                                                backgroundColor: "#0b243d",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexShrink: 0,
                                                mt: "2px",
                                            }}
                                        >
                                            <CheckIcon sx={{ fontSize: 15, color: "#ffc845" }} />
                                        </Box>
                                        <Box>
                                            <Box sx={{ fontSize: "0.95rem", fontWeight: 700, color: "#0b243d" }}>{item.titulo}</Box>
                                            <Box sx={{ fontSize: "0.85rem", color: "#6b7280", lineHeight: 1.4 }}>{item.texto}</Box>
                                        </Box>
                                    </Box>
                                </motion.div>
                            ))}
                        </Box>

                        <Box sx={{ mt: 4, display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 1.5 }}>
                            <Button
                                variant="contained"
                                onClick={() => navigate("../Planos")}
                                sx={{
                                    px: 4,
                                    py: 1.75,
                                    fontSize: "1rem",
                                    fontWeight: 700,
                                    textTransform: "none",
                                    backgroundColor: "#ffc845",
                                    color: "#0b243d",
                                    borderRadius: "10px",
                                    boxShadow: "0 8px 24px rgba(255, 200, 69, 0.35)",
                                    transition: "all 0.2s ease",
                                    '&:hover': {
                                        backgroundColor: "#e9b53d",
                                        transform: "translateY(-2px)",
                                        boxShadow: "0 10px 28px rgba(255, 200, 69, 0.45)",
                                    },
                                }}
                            >
                                Ver planos
                            </Button>
                            <Button
                                variant="outlined"
                                onClick={() => navigate("../SobreNos")}
                                sx={{
                                    px: 4,
                                    py: 1.75,
                                    fontSize: "1rem",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    color: "#0b243d",
                                    borderColor: "rgba(11, 36, 61, 0.3)",
                                    borderRadius: "10px",
                                    transition: "all 0.2s ease",
                                    '&:hover': {
                                        borderColor: "#0b243d",
                                        backgroundColor: "rgba(11, 36, 61, 0.04)",
                                        transform: "translateY(-2px)",
                                    },
                                }}
                            >
                                Conheça a Clarea
                            </Button>
                        </Box>
                    </motion.div>
                </Box>
            </Box>
            <Box
                component="section"
                sx={{
                    position: "relative",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    background: "linear-gradient(180deg, #0b243d 0%, #12365a 100%)",
                    py: { xs: 8, md: 12 },
                    overflow: "hidden",
                }}
            >
                {/* Detalhes decorativos */}
                <Box
                    sx={{
                        position: "absolute",
                        top: { xs: -80, md: -120 },
                        right: { xs: -80, md: -120 },
                        width: { xs: 220, md: 340 },
                        height: { xs: 220, md: 340 },
                        borderRadius: "50%",
                        border: { xs: "36px solid #ffc845", md: "56px solid #ffc845" },
                        opacity: 0.12,
                        pointerEvents: "none",
                    }}
                />
                <Box
                    sx={{
                        position: "absolute",
                        bottom: { xs: -100, md: -160 },
                        left: { xs: -100, md: -160 },
                        width: { xs: 240, md: 380 },
                        height: { xs: 240, md: 380 },
                        borderRadius: "50%",
                        border: { xs: "36px solid #ffffff", md: "56px solid #ffffff" },
                        opacity: 0.05,
                        pointerEvents: "none",
                    }}
                />

                <Box sx={{ position: "relative", zIndex: 1, width: "90%", maxWidth: "1000px", textAlign: "center" }}>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.4 }}
                        transition={{ duration: 0.6 }}
                    >
                        <Box
                            sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 1,
                                px: 1.75,
                                py: 0.75,
                                mb: 2.5,
                                borderRadius: "999px",
                                backgroundColor: "rgba(255, 200, 69, 0.12)",
                                border: "1px solid rgba(255, 200, 69, 0.4)",
                                color: "#ffc845",
                                fontSize: "0.8rem",
                                fontWeight: 600,
                                letterSpacing: "0.5px",
                                textTransform: "uppercase",
                            }}
                        >
                            <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "#ffc845" }} />
                            Vídeo de apresentação
                        </Box>

                        <h2
                            style={{
                                margin: "0 auto 16px",
                                maxWidth: "760px",
                                fontSize: "clamp(1.8rem, 3.4vw, 2.6rem)",
                                fontWeight: 800,
                                lineHeight: 1.2,
                                letterSpacing: "-0.5px",
                                color: "#fff",
                            }}
                        >
                            Descubra como podemos <span style={{ color: "#ffc845" }}>transformar sua relação</span> com a contabilidade
                        </h2>

                        <Box component="p" sx={{ m: "0 auto", maxWidth: "620px", fontSize: { xs: "1rem", md: "1.08rem" }, lineHeight: 1.7, color: "rgba(255, 255, 255, 0.8)" }}>
                            Veja como a Clarea cuida da parte burocrática para você focar no que realmente importa: seus pacientes.
                        </Box>
                    </motion.div>

                    {/* Vídeo */}
                    <motion.div
                        initial={{ opacity: 0, y: 40, scale: 0.97 }}
                        whileInView={{ opacity: 1, y: 0, scale: 1 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ delay: 0.2, duration: 0.8 }}
                    >
                        <Box
                            sx={{
                                mt: { xs: 5, md: 6 },
                                p: { xs: "6px", md: "10px" },
                                borderRadius: { xs: "18px", md: "24px" },
                                background: "linear-gradient(135deg, rgba(255, 200, 69, 0.6) 0%, rgba(255, 255, 255, 0.12) 50%, rgba(255, 200, 69, 0.35) 100%)",
                                boxShadow: "0 30px 80px rgba(0, 0, 0, 0.45)",
                            }}
                        >
                            <Box
                                sx={{
                                    position: "relative",
                                    paddingBottom: "56.25%", // Proporção 16:9
                                    height: 0,
                                    overflow: "hidden",
                                    borderRadius: { xs: "12px", md: "16px" },
                                    backgroundColor: "#000",
                                }}
                            >
                                <video
                                    src="/assets/VideoApresentacao.mp4"
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                    }}
                                    controls
                                    playsInline
                                    preload="metadata"
                                />
                            </Box>
                        </Box>
                    </motion.div>

                    {/* Chamada para ação */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.3, duration: 0.6 }}
                    >
                        <Box
                            sx={{
                                mt: { xs: 5, md: 6 },
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                alignItems: "center",
                                justifyContent: "center",
                                gap: { xs: 1.5, sm: 3 },
                            }}
                        >
                            <Button
                                variant="contained"
                                onClick={() => navigate("../Planos")}
                                sx={{
                                    width: { xs: "100%", sm: "auto" },
                                    px: 4,
                                    py: 1.75,
                                    fontSize: "1rem",
                                    fontWeight: 700,
                                    textTransform: "none",
                                    backgroundColor: "#ffc845",
                                    color: "#0b243d",
                                    borderRadius: "10px",
                                    boxShadow: "0 8px 24px rgba(255, 200, 69, 0.35)",
                                    transition: "all 0.2s ease",
                                    '&:hover': {
                                        backgroundColor: "#e9b53d",
                                        transform: "translateY(-2px)",
                                        boxShadow: "0 10px 28px rgba(255, 200, 69, 0.45)",
                                    },
                                }}
                            >
                                Quero minha contabilidade em dia
                            </Button>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: "rgba(255, 255, 255, 0.75)", fontSize: "0.9rem" }}>
                                <CheckIcon sx={{ fontSize: 18, color: "#ffc845" }} />
                                Sem multa e sem fidelidade
                            </Box>
                        </Box>
                    </motion.div>
                </Box>
            </Box>
            <WhatWeDo scrollToPlans={scrollToPlans} />
            {/* <SimulacaoImpostos /> */}
            <Box
                component="section"
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    backgroundColor: "#fff",
                    py: { xs: 8, md: 12 },
                    overflow: "hidden",
                }}
            >
                <Box
                    sx={{
                        width: "90%",
                        maxWidth: "1280px",
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                        alignItems: "center",
                        gap: { xs: 6, md: 8 },
                    }}
                >
                    {/* Texto */}
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <Box
                            sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 1,
                                px: 1.75,
                                py: 0.75,
                                mb: 2.5,
                                borderRadius: "999px",
                                backgroundColor: "rgba(255, 200, 69, 0.25)",
                                color: "#0b243d",
                                fontSize: "0.8rem",
                                fontWeight: 700,
                                letterSpacing: "0.5px",
                                textTransform: "uppercase",
                            }}
                        >
                            <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "#ffc845" }} />
                            Planos
                        </Box>

                        <h2 style={{ margin: "0 0 20px", fontSize: "clamp(1.8rem, 3.4vw, 2.6rem)", fontWeight: 800, lineHeight: 1.2, letterSpacing: "-0.5px", color: "#0b243d" }}>
                            Escolha o plano ideal para seu{" "}
                            <span style={{ color: "#c8961e" }}>consultório ou clínica.</span>
                        </h2>

                        <Box component="p" sx={{ m: 0, fontSize: { xs: "1rem", md: "1.08rem" }, lineHeight: 1.7, color: "#4b5563" }}>
                            Sabemos que cada especialidade da área da saúde tem suas próprias necessidades. Por isso, desenvolvemos <b style={{ color: "#0b243d" }}>planos personalizados</b> para cada perfil de profissional:
                        </Box>

                        {/* Especialidades atendidas */}
                        <Box sx={{ mt: 3, display: "flex", flexWrap: "wrap", gap: 1 }}>
                            {["Médicos", "Dentistas", "Psicólogos", "Fisioterapeutas", "Clínicas", "E outros profissionais da saúde"].map((especialidade, index) => (
                                <motion.div
                                    key={especialidade}
                                    initial={{ opacity: 0, y: 10 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: 0.3 + index * 0.06, duration: 0.3 }}
                                >
                                    <Box
                                        sx={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 0.75,
                                            px: 1.5,
                                            py: 0.75,
                                            borderRadius: "999px",
                                            backgroundColor: "#f9fafb",
                                            border: "1px solid #eef0f3",
                                            fontSize: "0.85rem",
                                            fontWeight: 600,
                                            color: "#0b243d",
                                        }}
                                    >
                                        <CheckIcon sx={{ fontSize: 16, color: "#c8961e" }} />
                                        {especialidade}
                                    </Box>
                                </motion.div>
                            ))}
                        </Box>

                        <Box sx={{ mt: 4, display: "flex", flexDirection: { xs: "column", sm: "row" }, alignItems: { xs: "stretch", sm: "center" }, gap: { xs: 1.5, sm: 3 } }}>
                            <Button
                                variant="contained"
                                onClick={scrollToPlans}
                                sx={{
                                    px: 4,
                                    py: 1.75,
                                    fontSize: "1rem",
                                    fontWeight: 700,
                                    textTransform: "none",
                                    backgroundColor: "#ffc845",
                                    color: "#0b243d",
                                    borderRadius: "10px",
                                    boxShadow: "0 8px 24px rgba(255, 200, 69, 0.35)",
                                    transition: "all 0.2s ease",
                                    '&:hover': {
                                        backgroundColor: "#e9b53d",
                                        transform: "translateY(-2px)",
                                        boxShadow: "0 10px 28px rgba(255, 200, 69, 0.45)",
                                    },
                                }}
                            >
                                Comparar planos
                            </Button>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: { xs: "center", sm: "flex-start" }, gap: 1, color: "#6b7280", fontSize: "0.9rem" }}>
                                <CheckIcon sx={{ fontSize: 18, color: "#c8961e" }} />
                                Sem multa e sem fidelidade
                            </Box>
                        </Box>
                    </motion.div>

                    {/* Imagem */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <Box sx={{ position: "relative", maxWidth: { xs: "520px", md: "none" }, mx: "auto" }}>
                            {/* Detalhes decorativos (espelhados em relação à seção "A Clarea") */}
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: { xs: -24, md: -36 },
                                    right: { xs: -24, md: -36 },
                                    width: { xs: 110, md: 160 },
                                    height: { xs: 110, md: 160 },
                                    borderRadius: "50%",
                                    border: { xs: "20px solid #ffc845", md: "28px solid #ffc845" },
                                    opacity: 0.35,
                                    zIndex: 0,
                                }}
                            />
                            <Box
                                sx={{
                                    position: "absolute",
                                    left: { xs: -12, md: -20 },
                                    bottom: { xs: -12, md: -20 },
                                    width: "60%",
                                    height: "60%",
                                    borderRadius: "24px",
                                    backgroundColor: "#0b243d",
                                    zIndex: 0,
                                }}
                            />

                            <Box
                                component="img"
                                src="/assets/planos.jpeg"
                                alt="Profissional da saúde"
                                sx={{
                                    position: "relative",
                                    zIndex: 1,
                                    display: "block",
                                    width: "100%",
                                    height: "auto",
                                    borderRadius: "24px",
                                    objectFit: "cover",
                                    boxShadow: "0 20px 50px rgba(11, 36, 61, 0.25)",
                                }}
                            />

                            {/* Card flutuante */}
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: 0.6, duration: 0.6 }}
                                style={{ position: "absolute", right: "-4%", bottom: "8%", zIndex: 2 }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1.5,
                                        backgroundColor: "#fff",
                                        borderRadius: "14px",
                                        px: { xs: 1.5, md: 2 },
                                        py: { xs: 1.25, md: 1.5 },
                                        boxShadow: "0 12px 30px rgba(11, 36, 61, 0.2)",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: { xs: 34, md: 40 },
                                            height: { xs: 34, md: 40 },
                                            borderRadius: "10px",
                                            backgroundColor: "#ffc845",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            flexShrink: 0,
                                        }}
                                    >
                                        <CheckIcon sx={{ color: "#0b243d", fontSize: { xs: 20, md: 24 } }} />
                                    </Box>
                                    <Box>
                                        <Box sx={{ fontSize: { xs: "0.8rem", md: "0.9rem" }, fontWeight: 700, color: "#0b243d", lineHeight: 1.2 }}>
                                            Planos sob medida
                                        </Box>
                                        <Box sx={{ fontSize: { xs: "0.7rem", md: "0.78rem" }, color: "#6b7280", lineHeight: 1.3 }}>
                                            Para cada especialidade
                                        </Box>
                                    </Box>
                                </Box>
                            </motion.div>
                        </Box>
                    </motion.div>
                </Box>
            </Box>
            <section
                style={{
                    width: "100%",
                    minHeight: "500px",
                    background: "linear-gradient(135deg, #0b243d 0%, #1b3a5d 100%)",
                    padding: "60px 20px",
                    boxSizing: "border-box",
                    color: "#ffffff",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <div
                    style={{
                        width: "100%",
                        maxWidth: "800px",
                        textAlign: "center",
                        marginBottom: "30px",
                        padding: "0 10px",
                    }}
                >
                    <h1
                        style={{
                            fontSize: "clamp(1.2rem, 4vw, 2.5rem)",
                            margin: 0,
                            lineHeight: 1.3,
                            color: "#ffffff",
                        }}
                    >
                        Descubra se sua cidade também é compatível.
                    </h1>
                    <p
                        style={{
                            marginTop: "10px",
                            color: "#ffc845",
                            fontSize: "clamp(0.9rem, 2vw, 1.1rem)",
                            lineHeight: 1.5,
                        }}
                    >
                        O emissor Clarea Fácil está homologado em mais de 2.000 cidades e compatível com centenas de padrões de Nota Fiscal de Serviço (NFS-e) em todo o Brasil. <a href="/assets/csvCidades/Cidades_homologadas.xlsx" download style={{ color: "#ffc845", textDecoration: "underline" }}>baixe aqui</a>
                    </p>
                </div>

                <div
                    style={{
                        width: "100%",
                        maxWidth: "600px",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        gap: "20px",
                        margin: "0 auto",
                        padding: "0 10px",
                    }}
                >
                    <TextField
                        placeholder="Digite sua cidade"
                        fullWidth
                        variant="outlined"
                        sx={{
                            width: { xs: "100%", sm: "80%", md: "60%" },
                            backgroundColor: "#ffffff",
                            borderRadius: "8px",
                            "& .MuiInputBase-input": {
                                color: "#0b243d",
                            },
                            "& .MuiInputLabel-root": {
                                color: "#0b243d",
                            },
                            "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                    borderColor: "#ffffff",
                                },
                                "&:hover fieldset": {
                                    borderColor: "#ffc845",
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: "#ffc845",
                                },
                            },
                        }}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <PlaceIcon sx={{ color: "#0b243d", mr: 1 }} position="start" />
                                ),
                            },
                        }}
                        onChange={e => handleFilterCity(e.target.value)}
                    />
                </div>
                <div
                    style={{
                        width: "100%",
                        maxWidth: "600px",
                        marginTop: "20px",
                        padding: "10px",
                    }}
                >
                    {
                        !cidadesFiltered ? (
                            <div style={{ textAlign: "center", marginTop: "20px" }}>
                                <p>Cidade não encontrada.</p>
                            </div>
                        ) : (
                            cidadesFiltered.map((cidade, index) => {
                                const rowStyle = {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                    flexWrap: "wrap",
                                    gap: "12px",
                                    marginTop: "10px",
                                };

                                const infoBoxStyle = {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "4px",
                                    minWidth: "120px",
                                };

                                const chipBoxStyle = {
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "8px",
                                    marginTop: "12px",
                                };

                                return (
                                    <div
                                        key={index}
                                        style={{
                                            backgroundColor: "#1b3a5d",
                                            padding: "15px",
                                            borderRadius: "10px",
                                            color: "#fff",
                                            marginBottom: "20px",
                                            boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
                                        }}
                                    >
                                        {/* Linha 1: Cidade e UF */}
                                        <div style={rowStyle}>
                                            <div style={infoBoxStyle}>
                                                <span style={{ fontWeight: "600" }}>Cidade:</span>
                                                <span>{cidade.cidade}</span>
                                            </div>
                                            <div style={infoBoxStyle}>
                                                <span style={{ fontWeight: "600" }}>UF:</span>
                                                <span>{cidade.uf}</span>
                                            </div>
                                        </div>

                                        {/* Linha 2: Layout, Padrão e Código IBGE */}
                                        <div style={rowStyle}>
                                            <div style={infoBoxStyle}>
                                                <span style={{ fontWeight: "600" }}>Layout de integração:</span>
                                                <span>{cidade.layoutIntegracao}</span>
                                            </div>
                                            <div style={infoBoxStyle}>
                                                <span style={{ fontWeight: "600" }}>Padrão:</span>
                                                <span>{cidade.padrao}</span>
                                            </div>
                                            <div style={infoBoxStyle}>
                                                <span style={{ fontWeight: "600" }}>Código IBGE:</span>
                                                <span>{cidade.codigoIbge}</span>
                                            </div>
                                        </div>

                                        {/* Linha 3: Dados obrigatórios das notas tomadas */}
                                        {/* <div style={rowStyle}>
                                    <div style={{ ...infoBoxStyle, flex: "1 1 100%" }}>
                                        <span style={{ fontWeight: "600" }}>Dados obrigatórios das notas tomadas:</span>
                                        <span>{cidade.dadosObrigatoriosDasNotasTomadas}</span>
                                    </div>
                                </div> */}

                                        <Divider style={{ margin: "12px 0", borderColor: "#ffc845" }} />

                                        {/* Linha 4: Chips */}
                                        <div style={chipBoxStyle}>
                                            <Chip
                                                icon={
                                                    cidade.status === "Operante" ? (
                                                        <CheckIcon color="success" />
                                                    ) : (
                                                        <CloseIcon color="error" />
                                                    )
                                                }
                                                label={cidade.status === "Operante" ? "Cidade compatível com emissor Clarea Fácil" : "Cidade não compatível com emissor Clarea Fácil"}
                                                variant="outlined"
                                                sx={{ color: "#fff", borderColor: "#ffc845" }}
                                            />
                                        </div>
                                    </div>
                                );
                            })
                        )}
                </div>

            </section>


            <div ref={plansRef}>
                <Plans title="Escolha seu Plano" />
            </div>

            <Box
                component="section"
                sx={{
                    position: "relative",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    background: "linear-gradient(180deg, #0b243d 0%, #12365a 100%)",
                    color: "#fff",
                    py: { xs: 8, md: 12 },
                    overflow: "hidden",
                }}
            >
                {/* Detalhe decorativo */}
                <Box
                    sx={{
                        position: "absolute",
                        top: { xs: -90, md: -120 },
                        left: { xs: -90, md: -120 },
                        width: { xs: 220, md: 320 },
                        height: { xs: 220, md: 320 },
                        borderRadius: "50%",
                        border: { xs: "36px solid #ffc845", md: "52px solid #ffc845" },
                        opacity: 0.12,
                        pointerEvents: "none",
                    }}
                />

                <Box sx={{ position: "relative", zIndex: 1, width: "90%", maxWidth: "1280px" }}>
                    {/* Cabeçalho */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, amount: 0.4 }}
                        transition={{ duration: 0.6 }}
                    >
                        <Box sx={{ textAlign: "center", mb: { xs: 5, md: 6 } }}>
                            <Box
                                sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 1,
                                    px: 1.75,
                                    py: 0.75,
                                    mb: 2.5,
                                    borderRadius: "999px",
                                    backgroundColor: "rgba(255, 200, 69, 0.12)",
                                    border: "1px solid rgba(255, 200, 69, 0.4)",
                                    color: "#ffc845",
                                    fontSize: "0.8rem",
                                    fontWeight: 600,
                                    letterSpacing: "0.5px",
                                    textTransform: "uppercase",
                                }}
                            >
                                <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "#ffc845" }} />
                                Nichos
                            </Box>
                            <h2 style={{ margin: "0 auto 16px", maxWidth: "760px", fontSize: "clamp(1.8rem, 3.4vw, 2.6rem)", fontWeight: 800, lineHeight: 1.2, letterSpacing: "-0.5px", color: "#fff" }}>
                                Contabilidade pensada para <span style={{ color: "#ffc845" }}>você</span>
                            </h2>
                            <Box component="p" sx={{ m: "0 auto", maxWidth: "620px", fontSize: { xs: "1rem", md: "1.08rem" }, lineHeight: 1.7, color: "rgba(255, 255, 255, 0.8)" }}>
                                Cada especialidade tem sua rotina, seus impostos e suas obrigações. Encontre a sua e veja como podemos ajudar.
                            </Box>
                        </Box>
                    </motion.div>

                    {/* Cards dos nichos */}
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(4, 1fr)" },
                            gap: { xs: 2, md: 2.5 },
                        }}
                    >
                        {cards.map((obj, index) => (
                            <motion.div
                                key={index}
                                custom={index}
                                variants={cardVariants}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.2 }}
                            >
                                <Box
                                    onClick={() => navigate("../Nichos")}
                                    sx={{
                                        position: "relative",
                                        height: { xs: 220, md: 280 },
                                        borderRadius: "16px",
                                        overflow: "hidden",
                                        cursor: "pointer",
                                        border: "1px solid rgba(255, 255, 255, 0.08)",
                                        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.25)",
                                        transition: "transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease",
                                        "& img": { transition: "transform 0.5s ease" },
                                        "& .nicho-desc": { maxHeight: { xs: 80, md: 0 }, opacity: { xs: 1, md: 0 }, transition: "max-height 0.35s ease, opacity 0.35s ease" },
                                        "&:hover": {
                                            transform: "translateY(-4px)",
                                            borderColor: "rgba(255, 200, 69, 0.6)",
                                            boxShadow: "0 16px 40px rgba(0, 0, 0, 0.35)",
                                        },
                                        "&:hover img": { transform: "scale(1.08)" },
                                        "&:hover .nicho-desc": { maxHeight: 80, opacity: 1 },
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={obj.img}
                                        alt={obj.value}
                                        sx={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }}
                                    />
                                    {/* Degradê para leitura do texto */}
                                    <Box sx={{ position: "absolute", inset: 0, background: "linear-gradient(180deg, rgba(11, 36, 61, 0) 30%, rgba(11, 36, 61, 0.92) 100%)" }} />

                                    <Box sx={{ position: "absolute", left: 0, right: 0, bottom: 0, p: { xs: 2, md: 2.25 } }}>
                                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                                            <Box sx={{ fontSize: { xs: "1.05rem", md: "1.05rem" }, fontWeight: 700, lineHeight: 1.25 }}>
                                                {obj.value}
                                            </Box>
                                            <Box
                                                sx={{
                                                    width: 30,
                                                    height: 30,
                                                    borderRadius: "50%",
                                                    backgroundColor: "#ffc845",
                                                    color: "#0b243d",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <ArrowForwardIcon sx={{ fontSize: 18 }} />
                                            </Box>
                                        </Box>
                                        <Box className="nicho-desc" sx={{ overflow: "hidden" }}>
                                            <Box sx={{ pt: 1, fontSize: "0.85rem", lineHeight: 1.45, color: "rgba(255, 255, 255, 0.85)" }}>
                                                {obj.desc}
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </motion.div>
                        ))}
                    </Box>

                    {/* Chamada para ação */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.2, duration: 0.6 }}
                    >
                        <Box
                            sx={{
                                mt: { xs: 5, md: 6 },
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 1.5,
                            }}
                        >
                            <Button
                                variant="contained"
                                onClick={scrollToPlans}
                                sx={{
                                    width: { xs: "100%", sm: "auto" },
                                    px: 4,
                                    py: 1.75,
                                    fontSize: "1rem",
                                    fontWeight: 700,
                                    textTransform: "none",
                                    backgroundColor: "#ffc845",
                                    color: "#0b243d",
                                    borderRadius: "10px",
                                    boxShadow: "0 8px 24px rgba(255, 200, 69, 0.35)",
                                    transition: "all 0.2s ease",
                                    '&:hover': {
                                        backgroundColor: "#e9b53d",
                                        transform: "translateY(-2px)",
                                        boxShadow: "0 10px 28px rgba(255, 200, 69, 0.45)",
                                    },
                                }}
                            >
                                Encontrar meu plano
                            </Button>
                            <Button
                                variant="outlined"
                                onClick={() => navigate("../Nichos")}
                                sx={{
                                    width: { xs: "100%", sm: "auto" },
                                    px: 4,
                                    py: 1.75,
                                    fontSize: "1rem",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    color: "#fff",
                                    borderColor: "rgba(255, 255, 255, 0.4)",
                                    borderRadius: "10px",
                                    transition: "all 0.2s ease",
                                    '&:hover': {
                                        borderColor: "#fff",
                                        backgroundColor: "rgba(255, 255, 255, 0.08)",
                                        transform: "translateY(-2px)",
                                    },
                                }}
                            >
                                Conhecer os nichos
                            </Button>
                        </Box>
                    </motion.div>
                </Box>
            </Box>

            <HowItWorks />
            <Footer />
            <WhatsAppButton />
        </>
    );
}

export default Home;
